
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.css";
import { useHead } from "@vueuse/head";
// import { Head } from "@egoist/vue-head";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import Intro from "./App/Intro.vue";
import Photo from "./App/Photo.vue";
import Publication from "./App/Publication.vue";
import News from "./App/News.vue";
import Awards from "./App/Awards.vue";
import Teaching from "./App/Teaching.vue";
import Service from "./App/Service.vue";
import Gallery from "./App/Gallery.vue";
import Media from "./App/Media.vue";
import Hello from "./App/Hello.vue";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

export default defineComponent({
    name: "App",
    components: {
        Intro,
        Photo,
        Publication,
        News,
        Awards,
        Teaching,
        Service,
        Gallery,
        Media,
        Hello,
    },
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
            navShow: false,
        });

        const siteData = reactive({
            title: `Aoyu Wu's Home Page`,
            description: `I am a PhD candidate in Computer Science at the Hong Kong University of Science and Technology (since 2019), supervised by Prof. QU Huamin. I am an awardee of the Hong Kong PhD Fellowship Scheme.`,
        });

        useHead({
            // Can be static or computed
            title: computed(() => siteData.title),
            meta: [
                {
                    name: `description`,
                    content: computed(() => siteData.description),
                },
                {
                    name: "keywords",
                    content: "WU AOYU",
                },
            ],
        });

        const toggleNavbar = () => {
            state.navShow = !state.navShow;
        };

        return {
            ...toRefs(state),
            toggleNavbar,
        };
    },
    computed: {},
});
